import API from 'src/api'
import { http } from '../boot/axios'

export default {
  CAMPAIGN_URL: API.GRAPHQL_URL + 'campaigns/',
  ITEMS_URL: API.GRAPHQL_URL + 'campaign-items/',
  fetchPaginated (options = {}) {
    const { page, search, limit } = {
      ...{
        page: 1,
        search: null,
        limit: 30
      },
      ...options
    }
    return new Promise((resolve, reject) => {
      http.get(`${this.CAMPAIGN_URL}?limit=${limit}&page=${page}` + (search ? `&search=${search}` : ''))
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  fetch (id) {
    return new Promise((resolve, reject) => {
      http.get(this.CAMPAIGN_URL + `${id}`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  create (payload) {
    return new Promise((resolve, reject) => {
      http.post(this.CAMPAIGN_URL, payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  update (id, payload) {
    return new Promise((resolve, reject) => {
      http.put(this.CAMPAIGN_URL + id, payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  delete (id) {
    return new Promise((resolve, reject) => {
      http.delete(this.CAMPAIGN_URL + `${id}`)
        .then(response => { resolve(response) })
        .catch(error => { reject(error) })
    })
  },
  fetchItems (campaign_id) {
    return new Promise((resolve, reject) => {
      http.get(this.ITEMS_URL + campaign_id)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  createCampaignItem (payload) {
    return new Promise((resolve, reject) => {
      http.post(this.ITEMS_URL, payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  deleteCampaignItem (id) {
    return new Promise((resolve, reject) => {
      http.delete(this.ITEMS_URL + id)
        .then(response => { resolve(response) })
        .catch(error => { reject(error) })
    })
  },
  getUserCampaigns (payload) {
    return new Promise((resolve, reject) => {
      http.get(this.CAMPAIGN_URL + 'user-campaigns', { params: payload })
        .then(response => { resolve(response) })
        .catch(error => { reject(error) })
    })
  }
}
